import { css } from '@emotion/react';
import {
  Accordion, AccordionHeaderSize,
} from '~/_shared/baseComponents/accordion';
import { BoundaryItemContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/boundaryItem/boundaryItem.container';
import { BoundaryTerritoryContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/boundaryItem/boundaryTerritory.container';
import { type useBoundaryItems } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useBoundaryItems';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { BoundaryKeyHeaderInfoComponent } from './BoundaryKeyHeaderInfo.component';

const panelStyle = css({
  padding: 0,
});

export const BoundaryTerritoryGroupKeyComponent = ({
  activeBoundaryTerritoryGroup,
  boundaryTerritoryGroupName,
  boundaryItemsProps: {
    boundaryTerritoryList,
    displayBoundaryTerritories,
    areGroupBoundariesEmpty,
    sortedBoundaryList,
    boundaryPermissions,
  },
  isExpanded,
  mainEntity,
  shortenedSubEntity,
  onToggle,
}: {
  activeBoundaryTerritoryGroup: BoundaryTerritoryGroup;
  boundaryTerritoryGroupName: string;
  boundaryItemsProps: ReturnType<typeof useBoundaryItems>;
  isExpanded: boolean;
  mainEntity?: string;
  shortenedSubEntity?: string;
  onToggle: () => void;
}) => {
  return (
    <Accordion.Item
      onToggle={onToggle}
      open={isExpanded}
    >
      <Accordion.ItemHeading
        size={AccordionHeaderSize.Large}
      >
        <BoundaryKeyHeaderInfoComponent
          boundaryTerritoryGroupName={boundaryTerritoryGroupName}
          mainEntity={mainEntity}
          shortenedSubEntity={shortenedSubEntity}
        />
      </Accordion.ItemHeading>
      <Accordion.Panel css={panelStyle}>
        {displayBoundaryTerritories && boundaryTerritoryList.map(boundaryTerritory => {
          return (
            <BoundaryTerritoryContainer
              key={boundaryTerritory.boundaryTerritoryId}
              boundaryTerritory={boundaryTerritory}
              boundaryTerritoryGroup={activeBoundaryTerritoryGroup}
              legendMode
            />
          );
        })}
        {!areGroupBoundariesEmpty && !displayBoundaryTerritories &&
          sortedBoundaryList.map(boundary => {
            return (
              <BoundaryItemContainer
                boundary={boundary}
                boundaryPermissions={boundaryPermissions}
                boundaryTerritoryGroup={activeBoundaryTerritoryGroup}
                key={boundary.id}
                legendMode
              />
            );
          })
        }
      </Accordion.Panel>
    </Accordion.Item>
  );
};
